export const WaveDivider = () => {
  return <div className="wave-divider" data-testid="wave-divider" aria-hidden="true" />;
};

export default WaveDivider;
